import { render, staticRenderFns } from "./CardDetailParent.vue?vue&type=template&id=fb16f234&"
import script from "./CardDetailParent.vue?vue&type=script&lang=js&"
export * from "./CardDetailParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports